import { render } from "./adminToast.vue?vue&type=template&id=36ed99ba"
import script from "./adminToast.vue?vue&type=script&lang=js"
export * from "./adminToast.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\ozmetal\\AdminUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__